<script>
	// NPM Modules
	import { tick } from 'svelte';
	import collect from 'collect.js';
	// Stores
	import MarketTypeStore from '@/Stores/Sport/MarketTypeStore';
	import SportStore from '@/Stores/Sport/SportStore';
	// Partials
	import ListMarketTypes from '@/Partials/Sport/Manage/MarketTypes/_List.svelte';
	import CreateMarketType from '@/Partials/Sport/Manage/MarketTypes/_Create.svelte';
	import UpdateMarketType from '@/Partials/Sport/Manage/MarketTypes/_Update.svelte';
	// Components
	import Switch from '@/Components/Switch.svelte';

	export let sport;

	let marketTypes;
	let selectedMarketType;
	let showCreateMarketType = false;
	let showUpdateMarketType = false;
	let onlyShowManual = false;

	$: sport && $SportStore && getMarketTypes();
	$: filteredMarketTypes = marketTypes && (onlyShowManual || !onlyShowManual) && filterMarketTypes(marketTypes);

	function getMarketTypes() {
		MarketTypeStore.getMarketTypesForSport(sport.id).then(() => {
			marketTypes = $MarketTypeStore.sortBy('name') ?? null;
		});
	}

	async function openCreateMarketType() {
		showCreateMarketType = true;
		await tick();
		window.scrollTo(0, 0);
	}

	async function openUpdateMarketType() {
		showUpdateMarketType = true;
		await tick();
		window.scrollTo(0, 0);
	}

	function filterMarketTypes(marketTypesToBeFiltered) {
		let marketTypesToBeFilter = marketTypesToBeFiltered ?? collect();

		if (onlyShowManual) {
			marketTypesToBeFilter = marketTypesToBeFilter.where('is_manual', true);
		}

		return marketTypesToBeFilter.all();
	}
</script>

{#if showCreateMarketType}
	<CreateMarketType bind:open={showCreateMarketType} bind:sport on:created={() => getMarketTypes()} />
{:else if showUpdateMarketType}
	<UpdateMarketType
		bind:open={showUpdateMarketType}
		bind:marketType={selectedMarketType}
		on:updated={() => getMarketTypes()}
	/>
{/if}

<div>
	<div class="flex items-end justify-between w-full">
		<div class="flex flex-row">
			<Switch bind:checked={onlyShowManual} className="-mt-1 ml-6" />
			<div class="ml-3">Show manual types only</div>
		</div>
		<button on:click={() => openCreateMarketType()} class="btn btn-primary"> Create market type </button>
	</div>
	{#if marketTypes}
		<ListMarketTypes
			bind:sport
			bind:marketTypes={filteredMarketTypes}
			bind:selectedMarketType
			on:selected={() => openUpdateMarketType()}
		/>
	{/if}
</div>
